import Action from 'redux/helpers/createAction'
const name = 'backlinkChecker'

export const getResults = Action(name + '/GET_RESULTS')

export const getResultsSuccess = Action(
  name + '/GET_RESULTS_SUCCESS',
  (data, url) => ({
    data,
    url,
    complete: true
  })
)

export const getResultsFailure = Action(
  name + '/GET_RESULTS_FAILURE',
  error => ({
    error
  })
)

export const getResultsNotReady = Action(
  name + '/GET_RESULTS_NOT_READY',
  (data, url) => ({
    data,
    url,
    complete: false
  })
)

export const exportResults = Action(name + '/EXPORT_RESULTS', payload => ({
  payload
}))

export const exportResultsSuccess = Action(
  name + '/EXPORT_RESULTS_SUCCESS',
  data => ({
    data
  })
)

export const exportResultsFailure = Action(
  name + '/EXPORT_RESULTS_FAILURE',
  error => ({
    error
  })
)

export const getHistory = Action(name + '/GET_HISTORY', historyId => ({
  historyId
}))

export const getHistorySuccess = Action(
  name + '/GET_HISTORY_SUCCESS',
  data => ({
    data
  })
)

export const getHistoryFailure = Action(
  name + '/GET_HISTORY_FAILURE',
  error => ({
    error
  })
)

export const loadPrevious = Action(name + '/LOAD_PREVIOUS', historyId => ({
  historyId
}))

export const loadPreviousSuccess = Action(
  name + '/LOAD_PREVIOUS_SUCCESS',
  (data, url, depth, filter) => ({
    data,
    url,
    depth,
    filter,
    complete: true
  })
)

export const loadPreviousFailure = Action(
  name + '/LOAD_PREVIOUS_FAILURE',
  error => ({
    error
  })
)

export const resetResults = Action(name + '/RESET_RESULTS')

export const deleteHistoryItem = Action(name + '/DELETE_HISTORY_RESULTS', historyId => ({
  historyId
}))

export const deleteHistoryItemSuccess = Action(
  name + '/DELETE_HISTORY_RESULTS_SUCCESS',
  data => ({
    data
  })
)

export const deleteHistoryItemFailure = Action(
  name + '/DELETE_HISTORY_RESULTS_FAILURE',
  error => ({
    error
  })
)